class RecommendedProductsController {
    /*@ngInject*/
    constructor($log, $element, RecommendedProductsService) {
        $log.debug('RecommendedProductsController initialized');
        this.$element = $element;
        this.recommendedProductsService = RecommendedProductsService;
        this.productCodes = '';
    }

    hasRecommendedProducts() {
        if (this.productCodes.length) {
            return true;
        } else {
            return false;
        }
    }

    loadRecommendedProducts(componentId, componentLogic, maxProducts, isMockEnabled) {

        // Success handler for Emarsys recommendations
        let successCallback = (SC, render) => {
            let recommendedItems = [];
            for (var i = 0, l = SC.page.products.length; i < l; i++) {
                recommendedItems.push(SC.page.products[i].id);
            }
            this.productCodes = recommendedItems.join(',');
            this.recommendedProductsService.fillProductCarousel(componentId, this.productCodes);
        };

        if (isMockEnabled === true) {
            let mockProductCodes = this.$element.data('mock-products');
            this.productCodes = ('' + mockProductCodes).split(',', maxProducts).join(',');
            this.recommendedProductsService.fillProductCarousel(componentId, this.productCodes);
        } else {
            this.recommendedProductsService.requestRecommendedProducts(componentId, componentLogic, maxProducts, successCallback);
        }
    }
}

export default RecommendedProductsController;
